import http from './public'
// 自主设计获取性别信息
export const getTdcDictCagetoryByParent = (params) => {
  return http.fetchGet("/product/api/product/productCategorylist", params)
}
//自主设计获取品类
export const getTdcDictCagetoryByFid = (params) => {
  return http.fetchGet("/product/api/product/productCategorylist", params)
}
//自主设计获取风格
export const getTdcDictProductByCategoryId = (params) => {
  return http.fetchGet("/product/api/product/productlist", params)
}
export const getdcDictDressStylesByProductId = (params) => {
  return http.fetchPost("/api/within/tdc/getdcDictDressStylesByProductId", params)
}
export const selectMaterial = (params) => {
  return http.fetchPost("/product/api/product/selectMaterial", params)
}
// 获取版型接口
export const getSelectMallMailyardEditionTypeByProductId = (params) => {
  return http.fetchGet("/product/api/product/selectMallMailyardEditionTypeByProductId", params)
}
// 加工工艺接口
export const getMallMailyardProcessProcesslist = (params) => {
  return http.fetchGet("/product/api/product/mallMailyardProcessProcesslist", params)
}
//自主设计获取默认工艺 // 弃用
export const getDefaultCategory = (params) => {
  return http.fetchPost("/api/within/tdc/getDefaultCategory", params)
}
//选中量体信息
export const selectVolumeInfo = (params) => {
  return http.fetchStringPost("/product/api/product/selectVolumeInfo", params)
}
//自主设计获取面料
export const getTdcDictOptionalMaterialByCodeAndProductId = (params) => {
  return http.fetchPost("/product/api/product/getMaterial", params)
}

// 下载面料册
export const fabricDownloadAPI = (params) => {
  return http.fetchFileGet("product/api/product/exportMaterial", params)
}

// 下载部件册
export const partsDownloadAPI = (params) => {
  return http.fetchFileGet("product/api/technology/exportTechnology", params)
}

export const clearCache = (params) => {
  return http.fetchPost("/order/api/cart/clearCache", params)
}

//提交用户信息
export const measureCustomer = (params) => {
  return http.fetchPost("/user/api/measureCustomer/editNew", params)
}
export const deselectTechnology  = (params) => {
  return http.fetchPost("/api/within/tdc/deselectTechnology", params)
}
//自主设计获取分类
export const getTdcDictTechnologyCategoryByProductIdAndIsSpecial = (params) => {
  return http.fetchPost("/product/api/technology/getTechnologyCategoryGroup", params)
}
//自主设计获取二级分类 // 弃用
export const getTdcDictOptionalMaterialByGroupAndProductId = (params) => {
  return http.fetchPost("/api/within/tdc/getTdcDictOptionalMaterialByGroupAndProductId", params)
}
//自主设计获取工艺
/**
 * @param ProductId     选中 ProductId
 * @param group         左侧 左侧列表返回的  group
 * @param selectTdcid   当前选中的
 * @param isSpecial     固定 1
 */
export const getTdcDictTechnologyMessageByCategoryId = (params) => {
  return http.fetchPost("/product/api/technology/getTechnologyMessage", params)
}
export const getDepthDesignTechnology  = (params) => {
  return http.fetchPost("/api/within/tdc/getDepthDesignTechnology", params)
}
//自主设计通过id查询冲突和关联
export const getLinkOrCollideByTechnologyId = (params) => {
  return http.fetchPost("/api/within/tdc/getLinkOrCollideByTechnologyId", params)
}
//自主量体基础数据
export const getBodyMassingArgs = (params) => {
  return http.fetchPost("/product/api/product/getVolumeInfo" , params)
}
//自主量体着衣风格
export const getDressStyle = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getDressStyle/" + params, params)
}
//自主量体特体
export const getSpecialBodys = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getSpecialBodys/" + params, params)
}
//自主量体特体内容
export const getSpecialBodyLevels = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getSpecialBodyLevels/" + params, params)
}
//自主选择标准号
export const getStandardMassingArgs = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getStandardMassingArgs/" + params, params)
}
//自主选择对应值
export const getStandardMassingValues = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getStandardMassingValues", params)
}
// 自主设计 选择 工艺 
/**
 * @param tdcId     选中 id
 * @param productId 左侧 左侧列表返回的  productId
 * @param group     左侧 左侧列表返回的  group
 * @param group     左侧 左侧列表返回的  group
 */
export const getTechnologyCollideListById = (params) => {
  return http.fetchPost("/product/api/technology/selectTechnology", params)
}
export const unCheckTechnology = (params) => {
  return http.fetchPost("/product/api/technology/uncheckTechnology", params)
}

export const getTechnologyExtend = (params) => {
  return http.fetchPost("/product/api/technology/getTechnologyExtend", params)
}
// 深度设计 客户指定框
/**
 * @param  extendTdcId     当前 客户指定狂 id
 * @param  technologyTdcId 左侧 tdcID
 */
export const getMessageExtendItemList = (params) => {
  return http.fetchPost("/api/within/tdc/getMessageExtendItemList", params)
}

// 深度设计 客户指定框 选中
/**
 * @param  technologyTdcId  左侧id
 * @param  extendTdcId      客户指定 id
 * @param  itemList         选中 列表
 */
export const selectDepthDesignTechnology = (params) => {
  return http.fetchPost("/api/within/tdc/selectDepthDesignTechnology", params)
}
// 深度设计 提交前  显示数据
/**
 * @param productId   productId
 */
export const getOmsTdcDictTechnologyCategory = (params) => {
  return http.fetchPost("/product/api/technology/getTechnology", params)
}
//点击下一步更新获取信息
export const getnextupdate = (params) => {
  return http.fetchPost("/product/api/technology/getByKey", params)
}


export const getVolumeInfo = (params) => {
  return http.fetchPost("/order/api/cart/getVolumeInfo", params)
}

export const addCart = (params) => {
  return http.fetchPost("/order/api/cart/addCart", params)
}

//根据产品id获取面料分类
export const getMallOptionalMaterialByType = (params) => {
  return http.fetchPost("/product/api/technology/getMallOptionalMaterialByType", params)
}
// 深度设计 默认客户指定提醒
/**
 * @param productId   productId
 */
export const getMessageIsNull = (params) => {
  return http.fetchPost("/api/within/tdc/getMessageIsNull", params)
}
// 深度设计 离开页面
/**
 * @param 无
 */
export const delRedisUtil = (params) => {
  return http.fetchPost("/api/within/tdc/delRedisUtil", params)
}
// 更改3D
/**
 * @param productId  productId
 */
export const selectTechnologyCode = (params) => {
  // api/within/tdc/selectTechnologyCode
  return http.fetchPost("product/api/technology/getTechnologyMessageByProductId", params)
}
// 客户单号 重复
/**
 * @param orderNo 
 */
export const getOrderNoIsRepeat = (params) => {
  return http.fetchPost("/api/within/tdc/getOrderNoIsRepeat", params)
}

// 新增用户信息
/**
 * @param orderNo 
 */


// 快速下单
/**
 * @param productId       产品id  
 * @param technologyCode  工艺代码
 */
export const selectMessageTechnologyCode = (params) => {
  return http.fetchPost("/api/within/tdc/selectMessageTechnologyCode", params)
}
// 快速下单 类型 深度设计之类的
/**
 * @param productId      产品id  
 */
export const selectMessageTechnologyExtend = (params) => {
  return http.fetchPost("/api/within/tdc/selectMessageTechnologyExtend", params)
}
// 快速下单 类型 深度设计之类的
/**
 * @param technologyId   工艺id 
 */
export const selectMessageTechnologyExtendItem = (params) => {
  return http.fetchPost("/api/within/tdc/selectMessageTechnologyExtendItem", params)
}
// 快速下单 我的客户 获取 量体数据
/**
 * @param phone   工艺id 
 */
export const getUserMassingArgs = (params) => {
  return http.fetchPost("/api/within/tdc/measure/getUserMassingArgs", params)
}


// 高定 商品 图片
/**
  * @param orderNo 编号
  * @param imgBase 图片
*/
export const addCommodityImg = (params) => {
  return http.fetchPost("/api/within/tdc/order/addCommodityImg", params)
}
// 厘米 英寸 呼唤
/**
  * @param unit 中英
  * @param basicData   [{value:"",}]   需要转换的 目标
*/
export const inToCm = (params) => {
  return http.fetchStringPost("/api/within/tdc/measure/inToCm", params)
}

// 根据位置查询可选的图案
export const getPatternByPositionId = (params) => {
  return http.fetchPost("/product/api/technology/getPatternByPositionId", params)
}

// 购买次数
export const  getMallOrderCount = (params) => {
  return http.fetchGet("/order/api/order/getMallOrderCount", params)
}



// WEBPACK FOOTER //
// ./src/api/tdcGoods.js